// Importación de la función useNavigate desde react-router-dom para la navegación en la aplicación.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

// Importación de componentes de terceros desde Material-UI
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ListItemIcon from '@mui/material/ListItemIcon';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';


// Importación del servicio TodoDataService desde la ruta '../../hooks/services'
import TodoDataService from '../../hooks/services';

// Importación de archivos estáticos
import LogoHeader from '../../assets/Imagenes/LogoHeader.png';


import './css/styles.css'


// Definición de temas personalizados para estilos
const theme = createTheme();
theme.typography.body1 = {
  fontSize: '12px',
  fontWeight: 'bold !important',
  fontFamily: 'Itaca !important',
  '@media (max-width:1200px)': {
    fontSize: '11px',
    fontWeight: 'bold !important'
  },
};

const theme2 = createTheme();
theme2.typography.body1 = {
  fontSize: '12px',
  fontWeight: 'bold !important',
  fontFamily: 'Itaca !important',
  '@media (max-width:1200px)': {
    fontSize: '11px',
    fontWeight: 'bold !important'
  },
};

const drawerWidth = 240;

const HeaderColumba = ({ ListLink }) => {
  // Estado para controlar la apertura y cierre del menú lateral en dispositivos móviles
  const [mobileOpen, setMobileOpen] = useState(false);
  const [Ubicacion, setUbicacion] = useState('');
  const Raiz = TodoDataService.GetHost2();
  const [padding, setPadding] = useState(0);
  const [WidthMenu, setWidthMenu] = useState(1080);
  const [WidthLateral, setWidthLateral] = useState(0);



  // Función para alternar la apertura y cierre del menú lateral en dispositivos móviles
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  // Función para la navegación entre páginas de la aplicación
  const navigate = useNavigate();

  // Función para manejar el clic en los elementos del menú y redireccionar a las páginas correspondientes
  const handleClick = (link) => {
    navigate(link);
  };


  useEffect(() => {
    const handleResize = () => {

      const containerWidth = window.innerWidth * 0.8;
      if (containerWidth > 1080) {

        const paddingValue = Math.max(0, (containerWidth - 1080) / 2);
        setPadding(paddingValue);
        setWidthMenu(containerWidth - 2 * paddingValue);
        setWidthLateral(window.innerWidth * 0.1 + paddingValue);
      }
      else {
        setWidthLateral((window.innerWidth - 1080) / 2);
      }

    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call it initially to set the correct padding

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  // Contenido del menú lateral
  const drawer = (
    <Box onClick={handleDrawerToggle}  className='ContenedorMenuLateral'>
      <List>
        {ListLink.filter(item => item.show === true).map((item, index) => (
          item.name === 'COLUMBA'
            ?
            <Box key={index} className='ContenedorEnlacesMenuLateral'>
              <Button disableRipple onClick={() => handleClick('/')} sx={{ "&.MuiButtonBase-root:hover": { bgcolor: "transparent" } }}>
                <img width='80%' src={LogoHeader} alt='Logo Paloma' />
              </Button>
            </Box>
            :
            <ListItem key={item.name}>
              <ListItemButton disablePadding disableRipple onClick={() => { if (Ubicacion !== Raiz + item.path) { handleClick(item.path); setUbicacion(item.name); } else { window.location.reload(); } }} className='ButtonMenuLateral'>
                <ListItemText primary={item.name} />
              </ListItemButton>
            </ListItem>
        ))}
        <ListItem key='BLOG'>
          <ListItemButton disablePadding disableRipple onClick={() => window.open('https://blog.columbafunerales.com/', '_self')} className='ButtonMenuLateral'>
            <ListItemText primary='BLOG' />
          </ListItemButton>
        </ListItem>
         <ListItem key='Ayuda'>
          <ListItemButton disablePadding disableRipple onClick={() => window.open('https://ayudaclmb.proximasistemas.com.mx/', '_self')} className='ButtonMenuLateral'>
            <ListItemText primary='AYUDA' />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton disableRipple onClick={() => window.open(TodoDataService.GetNumberPhone(), "_blank")} className='ButtonMenuLateral'>
            <ListItemIcon className='ButtonWhatsAppIconMovil'>
              <WhatsAppIcon className='WhatsAppIconMovil'/>
            </ListItemIcon>
            <ListItemText primary={TodoDataService.GetNumberCall()}> </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );


  useEffect(() => {
    const OptenerUrl = () => {
      setUbicacion(window.location.href);
    }
    OptenerUrl();
  }, [window.location.href]);

  return (
    <Box
  sx={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: `${WidthLateral + WidthMenu + WidthLateral}px`, // solo ancho del menú + laterales
    height: '75px !important',
    zIndex: 1000,
  }}
>
<Box className='ContenedorEscritorio'>
      {/* Espacio en blanco a la izquierda del encabezado */}
      <Box sx={{ width: WidthLateral + 'px' }} className='SubContenedorEscritorio1'></Box>
      <Box sx={{ width: `${WidthMenu}px !important` }} className='SubContenedorEscritorio2'>
        {/* Logo de la aplicación */}
        <Box className='ContenedorLogoEscritorio'>
          <Box className='SubContenedorLogoEscritorio'>
            <Button disableRipple onClick={() => handleClick('/')} className='ButtonLogoEscritorio'>
              <img width='90%' src={LogoHeader} alt='Logo Paloma' />
            </Button>
          </Box>
        </Box>

        {/* Barra lateral de color amarillo */}
        <Box className='ContenedorMediaLuna' ></Box>

        {/* Enlaces de navegación en la barra superior */}
        <Box className='ContenedorEnlaces'>
          <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
            {ListLink.filter(item => item.show === true).map((item) => (
              <Button disableRipple onClick={() => { if (Ubicacion !== Raiz + item.path) { handleClick(item.path); } else { window.location.reload(); } }} key={item.name} sx={{  color: Ubicacion.includes(Raiz + item.path) ? item.path === '/' && Ubicacion !== Raiz + item.path ? '#3F3F3F' : '#D14081' : '#3F3F3F' }} className='EnlacesButton'>
                <ThemeProvider theme={theme}>
                  <Typography variant='body1'>{item.name}</Typography>
                </ThemeProvider>
              </Button>
            )
            )}
            <Button disableRipple onClick={() => window.open('https://blog.columbafunerales.com/', '_self')} key='BLOG' className='ButtonBlog'>
              <ThemeProvider theme={theme}>
                <Typography variant='body1'>BLOG</Typography>
              </ThemeProvider>
            </Button>
             <Button disableRipple onClick={() => window.open('https://ayudaclmb.proximasistemas.com.mx/', '_self')} key='Ayuda' className='ButtonBlog'>
              <ThemeProvider theme={theme}>
                <Typography variant='body1'>AYUDA</Typography>
              </ThemeProvider>
            </Button>
          </Box>
        </Box>

        {/* Iconos de WhatsApp y correo electrónico en la barra superior */}
        <Box className='ContenedorButtonEstaticos'>
          <Box className='SubContenedorButtonEstaticos'>
            <Button disableRipple component='' onClick={() => window.open(TodoDataService.GetNumberPhone(), "_blank")} className='ButtonEstaticos'>
              <WhatsAppIcon className='WhatsAppIcon'/>
              <ThemeProvider theme={theme2}>
                <Typography variant='body1'  className='WhatsAppText'>{TodoDataService.GetNumberCall()}</Typography>
              </ThemeProvider>
            </Button>
          </Box>
        </Box>

        {/* Barra superior en dispositivos móviles */}
        <Box className='ContenedorBarraMovil' >
          <Box className='SubContenedorBarraMovil' >
            <Box className='ContenedorLogoMovil'>
              <Button disableRipple onClick={() => handleClick('/')} className='ButtonLogoMovil' >
                <img src={LogoHeader} alt='Logo Paloma' />
              </Button>
            </Box>
            <Box className='SubContenedorBarraMovil2' ></Box>
            <Box className='SubContenedorBarraMovil3'>
              <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} className='ButtonDesplegableBarraMovil'>
                <MenuIcon className='MenuIcon'/>
              </IconButton>
            </Box>
          </Box>
        </Box>


      </Box>

      {/* Espacio en blanco a la derecha del encabezado */}
      <Box sx={{ width: WidthLateral + 'px' }} className='SubContenedorEscritorio3'></Box>


      {/* Navegación lateral en dispositivos móviles */}
      <nav className='NavMovil'>
        <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{ keepMounted: true }} className='SubNavMovil'>
          {drawer}
        </Drawer>
      </nav>
    </Box>
 </Box>


    
  );
}

export default HeaderColumba;